// extracted by mini-css-extract-plugin
module.exports = {"container":"Offices-module__container___2GIMe","office":"Offices-module__office___3jpu5","officeName":"Offices-module__officeName___2Zb-B"};